import { createSlice } from "@reduxjs/toolkit";
import { graphqlApi } from "../api";

const initialState = {
  _announcements: { current: [], previous: [] },
  announcements: { current: [], previous: [] }
};

const announcementsSlice = createSlice({
  name: "announcements",
  initialState,
  reducers: {
    setAnnouncements(state, action) {
      const payload = action?.payload
      const { current, previous } = payload?.announcements || {}
      if(Array.isArray(current)) {
        const currentIds = new Set(current.map(item => item.id))
        const existingIds = new Set(state._announcements.current.map(item => item.id))
        const sizesMatch = currentIds.size === existingIds.size
        const eachIdIsSame = sizesMatch && [...currentIds].every(id => existingIds.has(id))
        if (!eachIdIsSame) {
          const sorted = current
            .map((item) => {
              let sortPriority = item?.sortPriority;
              const max = (currentIds.size + existingIds.size)
              if (isNaN(sortPriority)) {
                const existingIndex = state._announcements.current.findIndex(
                  (existing) => existing.id === item.id
                );
                sortPriority = existingIndex !== -1 ? existingIndex : max;
              }
              return {
                ...item,
                sortPriority,
              };
            })
            .sort((a, b) => a.sortPriority - b.sortPriority)
            .map(({ sortPriority, ...item }) => item);
          state._announcements.current = sorted;
        }
      }
      if(Array.isArray(previous)) {
        state._announcements.previous = previous
      }
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      graphqlApi.endpoints.dismissAnnouncements.matchFulfilled,
      (state, action) => {
        const id = action?.meta?.arg?.originalArgs?.id
        if (id && state._announcements?.current) {
          state._announcements.current = state._announcements.current.filter(
            announcement => announcement.id !== id
          )
        }
      }
    );
  }
});

export const { setAnnouncements } = announcementsSlice.actions

export const selectAnnouncements = (state = {}) => {
    return state.announcements?._announcements;
  };

const reducers = {
  getAnnouncements: announcementsSlice.reducer,
};

export default reducers;

